import { render, staticRenderFns } from "./PrivateGroups.vue?vue&type=template&id=4925faa8&scoped=true"
import script from "./PrivateGroups.vue?vue&type=script&lang=js"
export * from "./PrivateGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925faa8",
  null
  
)

export default component.exports